import type { AxiosRequestConfig, AxiosResponse } from "axios";
import { api, generateQueryParamFromObj, prefix } from "@/api";
import type { languageTagType } from "@/types/translations";
import type { layerType } from "@/types/api";

const namespace = "language";

export const getLocales = async (config: AxiosRequestConfig = {}) => {
  return api<any>({
    url: `${prefix}/${namespace}/locale`,
    method: "GET",
    ...config,
  });
};

export const getLocalized = async (code: string, config: AxiosRequestConfig = {}) => {
  return api<AxiosResponse<any>>({
    url: `${prefix}/${namespace}/localized?code=${code}`,
    method: "GET",
    ...config,
  });
};

export const getTags = async (params?: {
  allApplications?: boolean
  search?: string
  page?: number,
  limit?: number
}, config: AxiosRequestConfig = {}) => {
  const query = generateQueryParamFromObj(params);
  return api<layerType<languageTagType>>({
    url: `${prefix}/${namespace}/tag?${query}`,
    method: "GET",
    ...config,
  });
};

export const createTag = (
  params: {
    application_ids: Array<number>,
    tag: string,
    labels: Array<{
      value:string,
      localeCode: string
    }>
  },
  config: AxiosRequestConfig = {}
) => {
  return api<void>({
    url: `${prefix}/${namespace}/tag`,
    method: "POST",
    data: params,
    ...config,
  });
};

export const updateTag = (
  id: string | number,
  params: Omit<languageTagType, 'id'>,
  config: AxiosRequestConfig = {}
) => {
  return api<void>({
    url: `${prefix}/${namespace}/tag/${id}`,
    method: "PUT",
    data: params,
    ...config,
  });
};

export const deleteTag = (id: string | number, config: AxiosRequestConfig = {}) => {
  return api<void>({
    url: `${prefix}/${namespace}/tag/${id}`,
    method: "DELETE",
    ...config,
  });
};